@for (item of navItemsArray; track item) {
    @switch (helper.itemType(item)) {
        @case ('group') {
            <sf-sidebar-nav-group
                #rla="routerLinkActive"
                [dropdownMode]="dropdownMode"
                [item]="item"
                [ngClass]="item | sidebarNavItemClass"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="show"
                [compact]="compact"
                (linkClick)="hideMobile()"></sf-sidebar-nav-group>
        }
        @case ('divider') {
            <sf-sidebar-nav-divider
                [sfHtmlAttributes]="item.attributes ?? {}"
                [item]="item"
                [ngClass]="item | sidebarNavItemClass" />
        }
        @case ('title') {
            <sf-sidebar-nav-title
                [sfHtmlAttributes]="item.attributes ?? {}"
                [item]="item"
                [ngClass]="item | sidebarNavItemClass"></sf-sidebar-nav-title>
        }
        @case ('label') {
            <sf-sidebar-nav-label [item]="item" [ngClass]="item | sidebarNavItemClass" />
        }
        @case ('empty') {
            <ng-container />
        }
        @default {
            <sf-sidebar-nav-link (linkClick)="hideMobile()" [item]="item" [ngClass]="item | sidebarNavItemClass" />
        }
    }
}
<ng-content />
